import React, {PureComponent, createRef} from 'react';
import {connect} from '~/redux/connect';
import dialogs from './dialogs';
import get from 'lodash/get';
import merge from "lodash/merge";
import { getCurrentModelId, getDialogPage, getItemId, getModelName, getParentId } from "../../stateGetter";
import { push } from 'redux-little-router';
import {compareKeys} from "mythil/object";
import { Button, dialogFactory, HStack, PortalHost, Portal, PortalProvider } from "~/native-ui";
import { withResponsivePropsResolved } from '../../hoc/withResponsiveProps';
import { pushClose } from '~/actions/navigation_actions';
const Dialog = dialogFactory({ PortalProvider })


const areStatePropsEqual = (prev, curr) => {
    return compareKeys(prev, curr, (prev, curr, key) => {
        switch (key) {
            case "currentModel": return compareKeys(prev, curr);
            default: return prev === curr;
        }
    })
}

const ButtonWithResponsiveProps = withResponsivePropsResolved(Button);
const DialogWithResponsiveProps = withResponsivePropsResolved(Dialog);

export class DialogContainer extends PureComponent {
    static propTypes = {};

    state = {
        active: false
    }

    static getDerivedStateFromProps(props) {
        return {
            active: !!props.dialogPage
        }
    }

    getDialogProps() {
        return {
            active: this.state.active
        }
    }

    actionBarRef = createRef();
    setActionBarRef = (node) => this.actionBarRef.current = node;

    render() {
        if (!this.state.active) return null;

        let DialogPage = get(dialogs, `${this.props.dialogPage}.component`, (() => null));
        let dialogProps = get(dialogs, `${this.props.dialogPage}.props`, {});
        let dialogResponsiveProps = get(dialogs, `${this.props.dialogPage}.responsiveProps.dialogProps`, {});
        let closeButtonProps = get(dialogs, `${this.props.dialogPage}.responsiveProps.closeButtonProps`, {});
        let actions = <HStack w="100%" alignItems="center" ref={this.setActionBarRef}><PortalHost name="dialogContainerButtons"></PortalHost></HStack>
        
        return (
            <DialogWithResponsiveProps type="medium-auto" { ...dialogProps } { ...dialogResponsiveProps } onOverlayClick={ this.props.onClose } { ...this.getDialogProps() } actions={actions}>
                <DialogPage onClose={ this.props.onClose } actionBarRef={this.actionBarRef} currentModel={ this.props.currentModel } />
                <Portal hostName="dialogContainerButtons">{ <ButtonWithResponsiveProps label={this.props.trans("close")} onClick={ this.props.onClose } { ...closeButtonProps } /> }</Portal>
            </DialogWithResponsiveProps>
        );
    }
}

const RXDialogContainer = connect(
    (state) => {
        const modelId = getCurrentModelId(state);
        const parentModelId = modelId && getParentId(state, modelId);

        const currentModelID = parentModelId || modelId
        return {
            dialogPage: getDialogPage(state),
            currentModel: {
                itemId: currentModelID && getItemId(state, currentModelID),
                modelName: currentModelID && getModelName(state, currentModelID),
            },
        }
    },
    (dispatch) => ({
        onClose: (options) => dispatch(pushClose())
    }),
    null,
    { areStatePropsEqual }
)(DialogContainer);

export default RXDialogContainer;